import http from "./http";

function getDevice(data) {
  return http.post(`deviceList`, data);
}
function addDevice(data) {
  return http.post(`add_Device`, data);
}
function updateDevice(data) {
  return http.post(`update_Device`, data);
}
function deleteDevice(data) {
  return http.post(`delete_Device`, data);
}

const DeviceService = {
  getDevice,
  addDevice,
  updateDevice,
  deleteDevice,
};

export default DeviceService;
